import { Link } from "react-router-dom"
import hospitalimage from "../images/hospital image.jpg"
import Nageswara from "../images/Sri Puvvada Nageswara Rao.jpg"
import Ajay from "../images/Shri Puvvada Ajay Kumar.jpeg"
import Nayan from "../images/Dr. Nayan Raj Puvvada.jpeg"
import patientrooms from "../images/patient rooms.jpg"
import surgicalsuites from "../images/surgical suites.jpg"
import CT from "../images/CT.jpg"
import Cardiac from "../images/Cardiac catheterization.jpg"
import Timeline from "../components/TimelineData"
import SEO from './SEO';

const About = () => {
  const schema = [
  {
    "@context": "https://schema.org",
    "@type": "MedicalOrganization",
    "name": "MAMS Hospitals",
    "url": "https://mamshospitals.com",
    "logo": "https://mamshospitals.com/MAMS-Logo.png",
    "description": "MAMS Hospitals - A legacy of healing, compassion, and excellence in healthcare since 1992.",
    "foundingDate": "1996",
    "founder": {
      "@type": "Person",
      "name": "Sri Puvvada Nageswara Rao"
    },
    "address": {
      "@type": "PostalAddress",
      "streetAddress": "Bachupally, Hyderabad, Telangana – 500090",
      "addressLocality": "Hyderabad",
      "addressRegion": "Telangana",
      "postalCode": "500090",
      "addressCountry": "IN"
    },
    "contactPoint": [
      {
        "@type": "ContactPoint",
        "contactType": "customer service",
        "telephone": "+91-7399999981",
        "email": "contact@mamshospitals.com",
        "availableLanguage": ["English", "Hindi", "Telugu"]
      }
    ],
    "sameAs": [
      "https://www.facebook.com/MAMSHospitals",
      "https://www.instagram.com/mams_hospitals"
    ]
  },


  {
    "@context": "https://schema.org",
  "@type": "Article",
  "mainEntityOfPage": {
    "@type": "WebPage",
    "@id": "https://mamshospitals.com/about"
  },
  "headline": "About MAMS Hospitals",
  "description": "Learn about the history, leadership, mission, vision, and state-of-the-art facilities at MAMS Hospitals in Bachupally, Hyderabad—offering compassionate and accessible healthcare since 1996.",
  "image": "https://mamshospitals.com/path-to-about-image.jpg",
  "author": {
    "@type": "Organization",
    "name": "MAMS Hospitals"
  },
  "publisher": {
    "@type": "Organization",
    "name": "MAMS Hospitals",
    "logo": {
      "@type": "ImageObject",
      "url": "https://mamshospitals.com/MAMS-Logo.png"
    }
  },
  "datePublished": "1996-05-01",
  "dateModified": "2025-09-10",
  "articleSection": [
    "History & Legacy",
    "Leadership",
    "Mission & Vision",
    "Facilities"
  ],
  "about": {
    "@type": "MedicalOrganization",
    "name": "MAMS Hospitals",
    "url": "https://mamshospitals.com",
    "founder": {
      "@type": "Person",
      "name": "Sri Puvvada Nageswara Rao"
    },
    "foundingDate": "1996",
    "address": {
      "@type": "PostalAddress",
      "streetAddress": "Bachupally",
      "addressLocality": "Hyderabad",
      "addressRegion": "Telangana",
      "postalCode": "500090",
      "addressCountry": "IN"
    },
    "telephone": "+91-7399999981",
    "MedicalSpecialty": [
      { "@type": "MedicalSpecialty", "name": "Cardiology" },
      { "@type": "MedicalSpecialty", "name": "Neurology" },
      { "@type": "MedicalSpecialty", "name": "Orthopaedics" },
      { "@type": "MedicalSpecialty", "name": "Paediatrics" }
    ],
    "contactPoint": {
      "@type": "ContactPoint",
      "contactType": "Customer Service",
      "telephone": "+91-7399999981",
      "availableLanguage": ["English", "Hindi", "Telugu"]
    },
    "sameAs": [
      "https://www.facebook.com/MAMSHospitals",
      "https://www.instagram.com/mams_hospitals"
    ]
  },
  "keywords": [
    "MAMS Hospitals history",
    "Mamata Educational Society",
    "Healthcare Hyderabad",
    "Hospital legacy Bachupally"
  ]
}
];

  

  return (
    <>
    <SEO
      title="About MAMS Hospitals"
      description="Learn about the history, leadership, mission, vision, and facilities of MAMS Hospitals."
      canonicalUrl="https://mamshospitals.com/about"
      schema={schema}
    />
    <div className="flex flex-col min-h-screen">
      {/* Hero Section */}
      <section className="bg-primary/5 py-12 md:py-12">
        <div className="container mx-auto px-4 max-w-6xl">
          <div className="text-center max-w-3xl mx-auto">
            <h1 className="text-3xl md:text-5xl font-bold text-gray-800 mb-6">About MAMS Hospitals</h1>
            <p className="text-lg text-gray-600 mb-8">
              A legacy of healing, compassion, and excellence in healthcare since 1992.
            </p>
          </div>
        </div>
      </section>

      {/* History & Legacy */}
      <section className="py-8 md:py-16 px-0 md:px-4">
        <div className="container mx-auto max-w-6xl">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center">
            <div>
              <h2 className="text-3xl font-bold text-gray-800 mb-6">Our History & Legacy</h2>
              <p className="text-gray-600 mb-4">
                Established in 1996 by Sri Puvvada Nageswara Rao, Mamata Educational Society has grown into a beacon of
                accessible and quality healthcare. A visionary leader, advocate, and former legislator, Sri Rao's
                commitment to education and social welfare led to the foundation of MAMS Hospital.
              </p>
              <p className="text-gray-600 mb-4">
                Over three decades, we've evolved into a trusted name in compassionate and advanced medical care for
                all, especially the underserved. MAMS General Hospital, part of this legacy, stands as a center of
                excellence offering comprehensive healthcare services at minimal or no cost to those in need.
              </p>
              <p className="text-gray-600">
                Today, we continue to build on our founder's vision, combining cutting-edge medical technology with
                compassionate care to serve our community.
              </p>
            </div>
            <div className="relative">
              <img
                src={hospitalimage}
                alt="MAMS Hospital History"
                className="rounded-lg shadow-lg w-full"
                
              />
              <div className="absolute -bottom-4 -right-4 bg-white p-3 rounded shadow-md border border-gray-200">
                <div className="text-teal-600 text-3xl font-bold">25+</div>
                <div className="text-sm text-gray-600">Years of Service</div>
              </div>
            </div>
          </div>
        </div>
      </section>

   

      {/* Leadership */}
      <section className="py-8 md:py-16 px-0 md:px-4 bg-primary/5">
        <div className="container mx-auto max-w-6xl">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold text-gray-800 mb-4">Our Leadership</h2>
            <p className="text-gray-600 max-w-2xl mx-auto">
              Led by experienced healthcare professionals and administrators committed to upholding our founding vision.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            <div className="bg-white p-6 rounded-lg border border-gray-200 shadow-sm text-center">
              <div className="w-32 h-40 mx-auto mb-4 overflow-hidden square-full ">
                <img
                  src={Nageswara}
                  alt="Dr. Ramesh Rao"
                  className="object-cover w-full h-full"
                />
              </div>
              <h3 className="text-xl font-bold mb-1">Sri Puvvada Nageswara Rao</h3>
              <p className="text-gray-500 mb-3">Founder</p>
              <p className="text-gray-600 text-sm">
                Mamata Educational Society was established in May 1996 by Sri Puvvada Nageswara Rao, who is a renowned politician ,a social worker and by dedication educationist and philanthropist of repute.
              </p>
            </div>

            <div className="bg-white p-6 rounded-lg border border-gray-200 shadow-sm text-center">
              <div className="w-32 h-40 mx-auto mb-4 overflow-hidden square-full">
                <img
                  src={Ajay}
                  alt="Dr. Meera Sharma"
                  className="object-cover w-full h-full"
                />
              </div>
              <h3 className="text-xl font-bold mb-1">Sri Puvvada Ajay Kumar</h3>
              <p className="text-gray-500 mb-3">Chairman</p>
              <p className="text-gray-600 text-sm">
                Shri Puvvada Ajay Kumar is the Chairman of Mamata Academy of Medical Sciences, bachupally in state of Telangana.He was the Transport Minister of Telangana since 2019-2023.He is also the chairman of Mamata Medical, Nursing and Dental colleges in Khammam.
              </p>
            </div>

            <div className="bg-white p-6 rounded-lg border border-gray-200 shadow-sm text-center">
              <div className="w-32 h-40 mx-auto mb-4 overflow-hidden square-full">
                <img
                    src="https://mamshospitals.mamscollege.com/wp-content/uploads/2026/06/Nayan.jpeg"
                    alt="Mr. Vijay Kumar"
                    className="object-cover w-full h-full"
                  />
              </div>
              <h3 className="text-xl font-bold mb-1">Dr. Nayan Raj Puvvada</h3>
              <p className="text-gray-500 mb-3">Managing Director</p>
              <p className="text-gray-600 text-sm">
                Dr Nayan Raj Puvvada is at the helm of the thought and ideology that has taken Mamata Academy of Medical Sciences to heights of perfection and success in terms of offering quality healthcare to patients as well as imparting the best medical education.
              </p>
            </div>
          </div>
        </div>
      </section>


         {/* Mission & Values */}
      <section className="py-8 md:py-16 px-0 md:px-4 ">
        <div className="container mx-auto max-w-6xl">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold text-gray-800 mb-4">Our Mission & Vision</h2>
            <p className="text-gray-600 max-w-2xl mx-auto">
              Guided by a commitment to excellence, compassion, and accessibility, we strive to provide the highest
              quality healthcare to all.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div className="bg-white p-6 rounded-lg border border-gray-200 shadow-sm">
              <div className="bg-teal-100 p-3 rounded-full w-14 h-14 flex items-center justify-center mb-4">
                <img
                 src="https://mamshospitals.com//vision.png"
                 alt="Doctor Icon"
                 className="w-6 h-20 object-contain"
                />
                {/* <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="text-teal-600"
                >
                  

                  <path img src="../images/CT.jpg"></path>
                </svg> */}
              </div>
              <h3 className="text-xl font-bold mb-3">VISION</h3>
              <p className="text-gray-600">
                 “To create a comprehensive and integrated healthcare facility with best clinical practices and cutting-edge technology”.
              </p>
            </div>

            {/* <div className="bg-white p-6 rounded-lg border border-gray-200 shadow-sm">
              <div className="bg-teal-100 p-3 rounded-full w-14 h-14 flex items-center justify-center mb-4">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="text-teal-600"
                >
                  <path d="M22 12h-4l-3 9L9 3l-3 9H2"></path>
                </svg>
              </div>
              <h3 className="text-xl font-bold mb-3">Clinical Excellence</h3>
              <p className="text-gray-600">
                We are committed to the highest standards of medical practice, continually improving our skills and
                integrating evidence-based approaches.
              </p>
            </div> */}

            <div className="bg-white p-6 rounded-lg border border-gray-200 shadow-sm">
              <div className="bg-teal-100 p-3 rounded-full w-14 h-14 flex items-center justify-center mb-4">
                <img
                 src="https://mamshospitals.com//mission.png"
                 alt="Doctor Icon"
                 className="w-6 h-20 object-contain"
                />
                {/* <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="text-teal-600"
                >
                  <img src="/images/mission.png" alt="My Image" />
                  
                  <path d="M2 18a1 1 0 0 0 1 1h18a1 1 0 0 0 1-1v-2a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1v2z"></path>
                  <path d="M10 10V5a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v5"></path>
                  <path d="M4 15v-3a6 6 0 0 1 6-6h0"></path>
                  <path d="M14 6h0a6 6 0 0 1 6 6v3"></path>
                </svg> */}
              </div>
              <h3 className="text-xl font-bold mb-3">MISSION</h3>
              <p className="text-gray-600">
                “To deliver state-of-the-art patient care services in a comprehensive manner to respect every individual 
                 with an emphasis on quality service and excellence at affordable cost”
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Timelinesection 
            <Timeline/> */}

       {/* State-of-the-Art Facilities */}
      <section className="py-8 md:py-16 px-0 md:px-4 ">
        <div className="container mx-auto max-w-6xl">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center">
            <div>
              <h2 className="text-3xl font-bold text-primary mb-6">State-of-the-Art Facilities</h2>
              <p className="text-gray-700 mb-4">
                At MAMS Hospitals, we integrate the latest medical technologies and infrastructure to provide the
                highest standard of care. Our facilities include:
              </p>
              <ul className="space-y-3">
                <li className="flex items-start gap-2">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="text-primary mt-1"
                  >
                    <polyline points="9 11 12 14 22 4"></polyline>
                    <path d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11"></path>
                  </svg>
                  <span className="text-gray-700">
                    Advanced diagnostic imaging centers with CT, MRI, and ultrasound capabilities
                  </span>
                </li>
                <li className="flex items-start gap-2">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="text-primary mt-1"
                  >
                    <polyline points="9 11 12 14 22 4"></polyline>
                    <path d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11"></path>
                  </svg>
                  <span className="text-gray-700">
                    Modern surgical suites equipped for minimally invasive procedures
                  </span>
                </li>
                <li className="flex items-start gap-2">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="text-primary mt-1"
                  >
                    <polyline points="9 11 12 14 22 4"></polyline>
                    <path d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11"></path>
                  </svg>
                  <span className="text-gray-700">Intensive care units with continuous monitoring systems</span>
                </li>
                <li className="flex items-start gap-2">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="text-primary mt-1"
                  >
                    <polyline points="9 11 12 14 22 4"></polyline>
                    <path d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11"></path>
                  </svg>
                  <span className="text-gray-700">
                    Cardiac catheterization laboratory for interventional procedures
                  </span>
                </li>
                <li className="flex items-start gap-2">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="text-primary mt-1"
                  >
                    <polyline points="9 11 12 14 22 4"></polyline>
                    <path d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11"></path>
                  </svg>
                  <span className="text-gray-700">Modern patient rooms designed for comfort and recovery</span>
                </li>
              </ul>
            </div>
            <div className="grid grid-cols-2 gap-4">
              <img
                src={Cardiac}
                alt="Cardiac"
                className="rounded-lg shadow-sm w-full h-auto"
              />
              <img
                src={surgicalsuites}
                alt="Surgical Suite"
                className="rounded-lg shadow-sm w-full h-auto"
              />
              <img
                src={CT}
                alt="Laboratory Facilities"
                className="rounded-lg shadow-sm w-full h-auto"
              />
              <img
                src= {patientrooms}
                alt="Patient Room"
                className="rounded-lg shadow-sm w-full h-auto"
              />
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-8 md:py-16 px-0 md:px-4 px-4">
        <div className="container mx-auto max-w-6xl">
          <div className="bg-[#096256] text-white rounded-xl py-2 md:py-16 px-2 md:px-4 shadow-lg text-center">
            <h2 className="text-2xl md:text-3xl font-bold mb-4">Experience the MAMS Difference</h2>
            <p className="text-white max-w-2xl mx-auto mb-8">
              Join thousands of satisfied patients who have trusted us with their health. Book an appointment today to
              experience our compassionate care and medical excellence.
            </p>
            {/* <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Link to="/book-appointment">
                <button className="bg-white text-teal-600 px-6 py-3 rounded-full font-medium hover:bg-gray-100 transition-colors">
                  Book an Appointment
                </button>
              </Link> 
              <Link to="/contact">
                <button className="bg-transparent text-white border border-white px-6 py-3 rounded-full font-medium hover:bg-white/20 transition-colors">
                  Contact Us
                </button>
              </Link>
            </div> */}
          </div>
        </div>
      </section>

     
      
    </div>
    </>
  )
}

export default About
